module.exports = __webpack_public_path__ + "static/media/settings.8ca8fb34.svg";